import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

// components
import {TaskFormComponent} from "../task-form/task-form.component";

// services
import {TasksService} from "../../../shared/services/tasks.service";
import {SnackbarService} from "../../../shared/services/snackbar.service";

// models
import {Task} from "../../../shared/models/tasks/task";
import {ApiMessage} from "../../../shared/models/api-message";
import {AuthService} from "../../../shared/services/auth.service";

@Component({
    selector: 'app-task-update',
    templateUrl: './task-update.component.html',
    styleUrl: './task-update.component.scss'
})
export class TaskUpdateComponent implements OnInit {

    @ViewChild('data') data!: TaskFormComponent;

    public isLoading = false;
    public taskID = 0;
    public task!: Task;

    constructor(private authService: AuthService,
                private tasksService: TasksService,
                private snackbarService: SnackbarService,
                private route: ActivatedRoute,
                private router: Router) {
    }

    ngOnInit(): void {
        this.taskID = Number(this.route.snapshot.paramMap.get('id'));
        this.getTaskData(this.taskID);
    }

    public closeForm(): void {
        this.router.navigateByUrl(`secure/task-show/${this.taskID}`).then();
    }

    public updateTask(): void {
        const userType = this.authService.user.type;
        this.tasksService.updateTask(userType, this.taskID, this.data.taskForm.getRawValue()).subscribe({
            next: (res: ApiMessage): void => {
                this.snackbarService.snackbarCustomComplete(res.message);
            },
            error: (e) => this.snackbarService.snackbarCustomError(e.error.message),
            complete: () => this.closeForm()
        })
    }

    private getTaskData(id: number): void {
        this.isLoading = true;
        const userType = this.authService.user.type;
        this.tasksService.getTask(userType, id).subscribe((task: Task): void => {
            this.task = task;
            this.isLoading = false;
        })
    }
}
